import { render, staticRenderFns } from "./maintainanceTaskDetailView.vue?vue&type=template&id=ed563a1e&scoped=true"
import script from "./maintainanceTaskDetailView.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetailView.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetailView.vue?vue&type=style&index=0&id=ed563a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed563a1e",
  null
  
)

export default component.exports